<template>
    <div style="border-radius: 4px; overflow: hidden;">
        <chartTitle>
            MEC Distribution (ng/L)
        </chartTitle>

        <lineChart ref="linechart" :lineChartData="mec.lineChartData" :height="height - 10" @loading="$emit('loading')"
            @loaded="$emit('loaded')"></lineChart>
    </div>
</template>



<script>
    import chartTitle from './base/chartTitle.vue'

    export default {
        components: {
            lineChart: () => import('./base/lineChart.vue'),
            chartTitle,
        },

        props: {
            mec: {
                required: false,
                //type: TODO: add I_MEC here. 
            },
            height: {
                type: Number,
                default: 300
            }
        },
    }

</script>

<style scoped>

</style>